import { Body1, styled } from "@iventis/styles";
import { Autocomplete, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { CadUploadConfigUnit } from "@iventis/domain-model/model/cadUploadConfigUnit";
import { WarningMessageComponent } from "@iventis/components/src/warning-message";
import { useUnitsSelected } from "../../state/hooks/use-units-selected";
import { ControlContainer } from "./map-zoom";
import { useSubjectContext } from "../../state/subjects-context";

export function UnitSelectorComponent() {
    const { units, setUnits } = useUnitsSelected();

    const { unitsError$ } = useSubjectContext();
    const [errorMessage, setErrorMessage] = useState<string | null>(null);

    useEffect(() => {
        const subscription = unitsError$.subscribe((message) => {
            setErrorMessage(message);
        });

        return () => {
            subscription.unsubscribe();
        };
    }, [unitsError$]);

    return (
        <ControlContainer>
            <Body1>Units</Body1>
            <Autocomplete
                className="unit-selector"
                value={units}
                options={Object.values(CadUploadConfigUnit) as string[]}
                onChange={(_, value) => setUnits(value as CadUploadConfigUnit | null)}
                disableClearable
                sx={{ width: "100%" }}
                renderInput={(params) => (
                    <TextField
                        // eslint-disable-next-line react/jsx-props-no-spreading
                        {...params}
                    />
                )}
            />
            {errorMessage && (
                <ErrorMessageContainer>
                    <WarningMessageComponent message={errorMessage} />
                </ErrorMessageContainer>
            )}
        </ControlContainer>
    );
}

const ErrorMessageContainer = styled.div`
    width: 90%;
    margin: 0 5%;
`;
